import React from "react";
import Base from "../core/Base";
import HeaderTitle from "../components/HeaderTitle";

const TermsAndConditions = () => {
    return (
        <Base>
            <HeaderTitle title='Terms And Conditions'/>
            <section className="contact-area ptb-100">
               <div className='container mt-5'>
                   <div className="card terms_cards">
                       <div className="card-body">
                           <h5 className='text-center card-header terms_heading'>Terms And Conditions</h5>
                           <p className="card-text mt-5">1. Fee will not refundable, adjustable, and transferable in any circumstances.</p>
                           <p className="card-text">2. If any issue related to fee then it will solve under Agra court jurisdiction only.</p>
                           <p className="card-text">3. Smoking and drinking are prohibited.
                           </p>
                           <p className="card-text">4. All students need to follow all SarkariZone library's rules and disciplines.
                           </p>
                           <p className="card-text">5. We take responsibility for student's data, it always safe. If in any case, it will leak then SarkariZone will responsible for this.     </p>
                           <p className="card-text">6. We did not allow students to change their shifts time. Students can change it only with a genuine reason after 15 days of joining the library.
                           </p>
                           <p className="card-text">7. Mobile phones and personal music players may not be used in the Library. if used then should be used earphones.
                           </p>
                           <p className='card-text'>8. Conversation should be kept to a minimum to avoid disturbing other users.
                           </p>
                           <p className='card-text'>9.  Shift will start on time and end with time. So students required to present on time and leave on time.
                           </p>
                           <p className='card-text'>10. You are responsible for informing us of any changes to your personal details, for example, change of address.
                           </p>
                       </div>
                   </div>
               </div>
            </section>
        </Base>
    );
};

export default TermsAndConditions;
